// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .simulator[data-v-57359a40] {\n  border: 1px dashed rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  padding: 0.85rem;\n  margin-top: 0.5rem;\n}\n.sim-table[data-v-57359a40] {\n  width: 100%;\n  max-width: 420px;\n  font-size: 0.875rem;\n}\n[dir] .sim-table td[data-v-57359a40] {\n  padding: 0.15rem 0;\n}\n[dir=ltr] .text-right[data-v-57359a40] {\n  text-align: right;\n}\n[dir=rtl] .text-right[data-v-57359a40] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
